import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import HeaderBanner from "./HeaderBanner/HeaderBanner";
import HeaderMobileNav from "./HeaderNav/HeaderMobileNav";
import HeaderNav from "./HeaderNav/HeaderNav";

import logo1 from "assets/img/OneForChildren_Logo.svg";
// import logo2 from "assets/img/logo.png";
import logo2 from "assets/img/wv-logo-2022.png";
import logo3 from "assets/img/wv-hope-joy-justice-logo-2022.png";
import "assets/css/header.css";

const userBar = (
    // <div className="hidden-xs display-inline mr-5 mt-17">
    <div className="hidden-xs display-inline mr-5">
        <Link id="link-my-profile" to="/user/profile" title="My Profile">
            My Profile
        </Link>
        <span className="spacer">|</span>
        <Link to="/logout">Log out</Link>
    </div>
);

const isAuthenticated = element => {
    if (localStorage.getItem("token")) {
        return element;
    }
};

const Header = props => {
    const [mobileMenu, toggleMobileMenu] = useState(false);

    return (
        <header className="header">
            {isAuthenticated(
                <>
                    {/* <div className="top-ad">Send help to fight the COVID-19 pandemic <a title="donate to fight covid 19" href="https://www.worldvision.org.ph/donate/covid-19-emergency-health-response/?utm_medium=myspon_top-ad">click here</a></div> */}

                    <HeaderMobileNav
                        childrenList={props.childrenList}
                        mobileMenuToggle={mobileMenu}
                    />
                </>
            )}

            <div
                onClick={() => toggleMobileMenu(!mobileMenu)}
                className={
                    mobileMenu ? "content-overlay active" : "content-overlay"
                }
            />

            <div id="header" className="container front top-header">
                <div className="row">
                    <div className="column-one two-columns">
                        {isAuthenticated(
                            <button
                                className="mobile-nav-menu-toggle"
                                onClick={() => toggleMobileMenu(!mobileMenu)}
                            >
                                <i className="fas fa-bars" />
                            </button>
                        )}
                    </div>

                    <div className="column-two two-columns d-flex">
                        <div className="col-xs-6 one-for-children">
                            <a
                                href="http://www.worldvision.org.ph/"
                                id="logo"
                                title="World Vision Home"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={logo3}
                                    // src={logo1}
                                    alt="world vision one for children"
                                />
                            </a>
                        </div>

                        <div className="col-xs-6 text-right d-flex justify-content-end align-items-center">
                            {isAuthenticated(userBar)}

                            {/* <a
                                href="http://www.worldvision.org.ph/"
                                id="logo"
                                title="World Vision Home"
                                className="display-inline wvlogo2"
                            >
                                <img src={logo2} alt="world vision logo" />
                            </a> */}
                        </div>
                    </div>
                </div>
            </div>

            <HeaderBanner bannerImage={props.bannerImage || undefined}>
                {isAuthenticated(
                    <HeaderNav childrenList={props.childrenList} />
                )}
            </HeaderBanner>
        </header>
    );
};

export default Header;
